import { Matrix4 as m } from "three";
import { matrixToRgTransform as p } from "../../geometry-utils/three/index16.js";
import { rotToSignedAngle as g } from "../../utils/index30.js";
const n = new m(), l = ({ obj: o, mx: e }) => {
  n.fromArray(e);
  const r = p(n), c = [r.pos[0], r.pos[2]], i = [o.size[0], o.size[2]], t = [
    -o.size[0] * o.anchor[0],
    -o.size[2] * o.anchor[2]
  ], s = g(r.rot), a = [s, -t[0], -t[1]];
  return { anchor: t, angle: s, pos: c, rotation: a, size: i };
};
export {
  l as get2dRgObjectValues
};
//# sourceMappingURL=index2.js.map
